import { filterObjectStore, queryFilter } from 'Redux/Query';

export const getReports = (state, filter = null) => {
    if(filter === null) {
        filter = queryFilter({sorting: { by: 'createdAt', order: 'DESC' }})
    }

    return filterObjectStore(state.report.reports.entries, filter);
};
